import { buildReducer, addOrRemoveElement } from '../../../shared';
import type PersonaLinkingState from '../../state/personaLinkingState';
import {
    unlinkContactClickedAction,
    unlinkContactCompletedAction,
    linkPersonasClickedAction,
    linkPersonasCompletedAction,
    cacheClearedAfterLinkingAction,
} from '../../actions/data/personaLinkingActions';
import { dismissLinkingDialogAction } from '../../actions/user/personaLinkingDialogActions';

export type { PersonaLinkingState };

const defaultState: PersonaLinkingState = {
    contactSourceIdsBeingUnlinked: [],
    personaLinkingFailed: false,
    isLinkingInProgress: false,
};

export default buildReducer<PersonaLinkingState>()
    .handle(unlinkContactClickedAction, (state, action) => ({
        ...state,
        contactSourceIdsBeingUnlinked: addOrRemoveElement(
            state.contactSourceIdsBeingUnlinked,
            action.payload.contactSourceId
        ),
    }))
    .handleDataAction(
        unlinkContactCompletedAction,
        (state, action) => {
            return {
                ...state,
                contactSourceIdsBeingUnlinked: addOrRemoveElement(
                    state.contactSourceIdsBeingUnlinked,
                    action.payload.unlinkedContactSourceId
                ),
            };
        },
        // For the moment, simply remove the spinner on error.
        (state, action) => ({
            ...state,
            contactSourceIdsBeingUnlinked: addOrRemoveElement(
                state.contactSourceIdsBeingUnlinked,
                action.payload.unlinkedContactSourceId
            ),
        })
    )
    .handle(linkPersonasClickedAction, state => ({
        ...state,
        personaLinkingFailed: false,
        isLinkingInProgress: true,
    }))
    .handleDataAction(
        linkPersonasCompletedAction,
        state => ({ ...state, personaLinkingFailed: false }),
        state => ({ ...state, personaLinkingFailed: true })
    )
    .handle(dismissLinkingDialogAction, state => ({
        ...state,
        personaLinkingFailed: false,
        isLinkingInProgress: false,
    }))
    .handleDataAction(
        cacheClearedAfterLinkingAction,
        state => ({ ...state, isLinkingInProgress: false }),
        state => ({ ...state, isLinkingInProgress: false })
    )
    .done(defaultState);
export type { Action } from '../../../shared';
